export const screenerCopyFr = {
    start: "Commencer",
    starting: "Démarrage...",
    checking: "Vérification de vos réponses...",
    notFoundTitle: "Ce lien ne fonctionne pas",
    notFoundBody: "Le questionnaire est peut-être fermé. Contactez l'équipe qui vous a donné ce lien.",
    eligibleTitle: "Vous pouvez participer",
    eligibleBody: "Créez votre compte pour commencer.",
    ineligibleTitle: "Ce programme ne vous convient pas",
    ineligibleBody:
        "Merci pour vos réponses. D'après vos réponses, vous ne remplissez pas les critères. Pour toute question, contactez l'équipe qui vous a donné ce lien.",
    continueToSignUp: "Continuer vers l'inscription",
    scanOnPhone: "Ou scannez ce code avec l'appareil photo de votre téléphone pour vous inscrire sur votre téléphone.",
    startAgain: "Recommencer",
};
